/**
 * ページローディングインジケーターを非表示
 *
 * @function hidePageLoading
 * @returns {void}
 */
export function hidePageLoading() {
  const loader = document.getElementById('pageLoading');
  if (!loader) {
    return;
  }
  loader.classList.add('loaded');
}

/**
 * ページローディングアニメーションを表示
 *
 * @function showPageLoading
 * @param {string|null} customText - 表示するカスタムテキスト（指定がなければデフォルトテキストを使用）
 * @returns {void}
 */
export function showPageLoading(customText = null) {
  const loader = document.getElementById('pageLoading');
  if (!loader) {
    return;
  }
  loader.classList.remove('loaded');
  // テキスト要素を取得
  const textElement = loader.querySelector('.loading-text');
  if (textElement) {
    // カスタムテキストが指定されていれば使用、なければデフォルトテキスト
    textElement.textContent = customText || 'ページを読み込んでいます...';
  }
}

/**
 * ページローディング非表示のタイムアウト時間（ミリ秒）
 *
 * @constant {number}
 */
const hidePageLoadingTimeoutMs = 100;

// ページロード完了時に自動的に非表示にする
window.addEventListener('pageshow', () => {
  setTimeout(hidePageLoading, hidePageLoadingTimeoutMs);
});
document.addEventListener('DOMContentLoaded', () => {
  setTimeout(hidePageLoading, hidePageLoadingTimeoutMs);
});

// フォーム送信時に表示する
document.querySelectorAll('form').forEach((form) => {
  form.addEventListener('submit', () => {
    if (form.getAttribute('target') === '_blank') {
      return;
    }

    if (form.dataset.loader === 'disabled' || form.hasAttribute('wire:submit')) {
      return;
    }

    // フォームにカスタムローディングテキストの属性があれば使用
    const loadingText = form.getAttribute('data-loading-text');
    showPageLoading(loadingText);
  });
});
